import {Component, OnInit} from '@angular/core';
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router} from "@angular/router";
import {Release} from "../../model/release";
import {FaqCategory} from "../../model/FaqCategory";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {MarkjsHighlightDirective} from "../../directives/markjsHighlight.directive";
import {SearchPipe} from "../../components/common/SearchPipe";
import {DatePipe} from "@angular/common";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';
import { BackToTopComponent } from 'src/app/components/common/back-to-top/back-to-top.component';

@Component({
    selector: 'app-release-notes',
    imports: [
        BreadcrumbComponent,
        SearchBarComponent,
        MarkjsHighlightDirective,
        SearchPipe,
        SpinnerComponent,
        DatePipe,
        BackToTopComponent
    ],
    templateUrl: './release-notes.component.html',
    styleUrl: './release-notes.component.scss'
})
export class ReleaseNotesComponent implements OnInit {

  allVersions: Release[];
  sortedByMinorVersions: Map<string, Release[]>;
  activeMinorVersion: string;
  allowedRnProducts: FaqCategory[];
  activeProduct: FaqCategory;
  search: string;

  constructor(private http: HttpClient,
              private route: ActivatedRoute,
              protected router: Router) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(param => {
      this.http.get<FaqCategory[]>("/api/v1/rn").subscribe(r => {
        this.allowedRnProducts = r;
        this.activeProduct = this.allowedRnProducts.find(x => x.name === param.get("slug"));
        if(!this.activeProduct) {
          // Product not found, redirect to /
          this.router.navigate(['']);
        }
        this.loadSlug(this.activeProduct.slug, param.get("version"));
      });
    });
  }

  loadSlug(slug: string, version: string): void {
    this.sortedByMinorVersions = new Map<string, Release[]>();
    this.activeMinorVersion = undefined;

    this.http.get<Release[]>("/api/v1/rn/" + slug).subscribe(c => {
      this.allVersions = c;
      // @ts-ignore
      this.allVersions.sort( (a, b) => a.name.replace(/\d+/g, n => +n+100000 )
        // @ts-ignore
        .localeCompare(b.name.replace(/\d+/g, n => +n+100000 )) ).reverse();

      let firstMinorVersion: string = undefined;
      this.allVersions.forEach(v => {
        // Get group with regex
        const minorFound = /(\d+\.\d+).*/.exec(v.name);
        if(minorFound.length > 1) {
          if(!this.sortedByMinorVersions.has(minorFound[1])){
            this.sortedByMinorVersions.set(minorFound[1], []);
          }
          if(!firstMinorVersion) {
            firstMinorVersion = minorFound[1]
          }
          if(!this.activeMinorVersion && version === minorFound[1]){
            this.activeMinorVersion = minorFound[1];
          }
          v.description_html = this.removeLinks(v.description_html);

          this.sortedByMinorVersions.get(minorFound[1]).push(v);
        }
      });
      if(!this.activeMinorVersion){
        this.activeMinorVersion = firstMinorVersion;
      }
    })
  }

  removeLinks(html: string): string {
    let elem = document.createElement('div')
    elem.innerHTML = html;

    Array.from(elem.children).forEach(child => {
      if (!(child.tagName.toUpperCase() === 'A')) {
        child.innerHTML = this.removeLinks(child.innerHTML);
        return;
      }
      child.replaceWith(document.createTextNode(child.textContent));
    });
    return elem.innerHTML;
  }

  updateRoute(version: string): void {
    this.activeMinorVersion = version;
    this.search = "";
    var newurl = window.location.protocol + "//" + window.location.host + '/';
    newurl += ['notes-de-version', this.activeProduct.name, this.activeMinorVersion].join('/');
    window.history.pushState({path: newurl}, '', newurl);
  }
}
